
<br />
<div class="center" *ngIf="!requestsCompleted">
  <app-calibrant-load [small]="true"></app-calibrant-load>
</div>
<div *ngIf="requestsCompleted && displayHeader">
  <div class="flex items-center justify-between">
    <h3 class="title-header">Dispatches</h3>
    <button *ngIf="program.programType === 'DEMAND_RESPONSE'" mat-flat-button color="primary" (click)="addNewDispatch()">Add Dispatch</button>
  </div>
  <br />
  <br />
  <hr />
</div>
<div class="mat-elevation-z8" matSort *ngIf="requestsCompleted && dispatches.length > 0">
  <table *ngIf="dataSource" mat-table multiTemplateDataRows [dataSource]="dataSource" style="width: 100%;">
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Dispatch Status</th>
      <td mat-cell *matCellDef="let element">
        <span class="font-weight-bold">{{element?.status}}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="setpoint">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Set Point</th>
      <td mat-cell *matCellDef="let element">{{cleanNumericOutput(element.setpoint)}} kW</td>
    </ng-container>
    <ng-container matColumnDef="requestedPower">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Requested Power</th>
      <td mat-cell *matCellDef="let element">{{cleanRequestedPower(element)}}</td>
    </ng-container>
    <ng-container matColumnDef="predictedOutput">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Planned Power</th>
      <td mat-cell *matCellDef="let element">
        {{element.predictedOutput}}
      </td>
    </ng-container>
    <ng-container matColumnDef="maxDispatchPower">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Max Power</th>
      <td mat-cell *matCellDef="let element">
        {{element?.maxDispatchPower}} kW
      </td>
    </ng-container>
    <ng-container matColumnDef="incentive">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Incentive</th>
      <td mat-cell *matCellDef="let element">{{cleanNumericOutput(element.incentive)}} $/kW</td>
    </ng-container>
    <ng-container matColumnDef="penalty">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Penalty</th>
      <td mat-cell *matCellDef="let element">{{cleanNumericOutput(element.penalty)}} $/kW</td>
    </ng-container>
    <ng-container matColumnDef="startTimeUtc">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Time</th>
      <td mat-cell *matCellDef="let element">{{element.startTimeUtc | date: dateFormatStr : element.shortZone}}
        <br />
        <em>({{element.shortZone}})</em>
      </td>
    </ng-container>
    <ng-container matColumnDef="endTimeUtc">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>End Time</th>
      <td mat-cell *matCellDef="let element">{{element.endTimeUtc | date: dateFormatStr : element.shortZone}}
        <br />
        <em>({{element.shortZone}})</em>
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Actions</th>
      <td mat-cell *matCellDef="let element">
        @if (element.status === DISPATCH_ERROR || element.status === DISPATCH_PENDING) {
          <mat-icon color="primary" matRipple matTooltip="Edit dispatch" (click)="editDispatch(element.id)" style="cursor: pointer">edit</mat-icon>
        } @else {
          <mat-icon attr-disabled matTooltip="Edit dispatch">edit</mat-icon>
      }
        <mat-icon color="warn " matRipple matTooltip="Remove dispatch" (click)="removeDispatch(element)" style="cursor: pointer">delete</mat-icon>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedColumns;"
        [ngClass]="{ 'selected': selection.isSelected(element)}"
        class="element-row"
        [class.expanded-row]="expandedElement === element"
    (click)="setSelectedDispatch(element); selection.select(element)">
    </tr>
  </table>
  <mat-paginator [pageSizeOptions]="[5, 10, 20, 50]"
                 showFirstLastButtons
                 [pageIndex]="0"
                 [pageSize]="pageSize"
                 aria-label="Select from dispatch list.">
  </mat-paginator>
</div>
<div *ngIf="dispatches.length == 0 && requestsCompleted" class="flex justify-center">
  <div class="flex flex-col items-center">
    <mat-icon style="margin: 1rem 0" matTooltip="No upcoming dispatches">info</mat-icon>
    <span>No upcoming dispatches</span>
  </div>
</div>
